import React, {useEffect} from 'react';
import {loadModules} from 'esri-loader';

const LayerList = ({view, setLayerList}) => {
    const nodeRef = React.createRef();

    let layerList;
    useEffect(() => {
        const runEffect = async () => {
            loadModules(['esri/widgets/LayerList'], {css: true}).then(([LayerList]) => {
                layerList = new LayerList({
                    view: view,
                    container: nodeRef.current
                });
                setLayerList(layerList);
            }).catch((err) => console.error(err));  
        }
        runEffect();
        return () => {
            if (!!layerList) {
                layerList.container = null;
            }
        }
    }, [nodeRef.current]);

    let node;
    return (
        <div id='layerList' ref={nodeRef}/>
    )  
}

export { LayerList };